module.exports = __webpack_public_path__ + "static/media/hair (25).e5bcfb11.jpg";